import React from 'react';
import PropTypes from 'prop-types';
import CircularProgress from 'components/pure/utils/CircularProgress';
import GenericLink from 'components/GenericLink';
import './LiveCoachingOverallScore.styl';
import CallDetails from 'records/CallDetails';
import {navToLiveCoachingCall} from 'components/coaching/CallLink';
import GenericTooltip from 'components/pure/tooltips/GenericTooltip';
import {TOOLTIP_DELAY} from 'components/StatsPage2.utils';
import {getMuiV4Theme} from 'utils/css/themeUtils';

export default class LiveCoachingOverallScore extends React.PureComponent {
  render() {
    const {reviewAverage, call, isRecipient, reviewId} = this.props;
    return (
      <div className="livecoaching-overall-score coaching-review-scorecard-details">
        <GenericTooltip
          hoverBehavior
          positionTop
          delay={TOOLTIP_DELAY}
          tooltip={
            <div>
              This shows the overall score result from the livecoaching session.
              {!isRecipient && <span> Click the link to see more details.</span>}
            </div>
          }>
          <div className="score call-question">
            {!isRecipient && (
              <GenericLink onClick={() => navToLiveCoachingCall(call, reviewId)}>
                <div className="label">Overall Live Coaching Score</div>
              </GenericLink>
            )}
            {isRecipient && <div className="label">Overall Live Coaching Score</div>}
            <div className="value rating">
              {Number.isNaN(reviewAverage) ? (
                <div className="no-score">
                  <span className="na-text">N/A</span>
                </div>
              ) : (
                <div className="score-ring">
                  <CircularProgress
                    color={getMuiV4Theme().palette.primary.main}
                    percentage={reviewAverage}
                  />
                  <span className="ring-label">{reviewAverage.toFixed(0)}%</span>
                </div>
              )}
            </div>
          </div>
        </GenericTooltip>
      </div>
    );
  }
}

LiveCoachingOverallScore.propTypes = {
  reviewAverage: PropTypes.any,
  call: PropTypes.instanceOf(CallDetails),
};
